import { render, staticRenderFns } from "./SupportTicketCreate.vue?vue&type=template&id=e73e40fe"
import script from "./SupportTicketCreate.vue?vue&type=script&lang=js"
export * from "./SupportTicketCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports